import _regeneratorRuntime from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
import { isInArray } from "../../../Utils/Utils";
export var Connector =
/*#__PURE__*/
function (_ExternalInteractorBa) {
  _inherits(Connector, _ExternalInteractorBa);

  function Connector(container) {
    _classCallCheck(this, Connector);

    return _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this, container));
  }

  _createClass(Connector, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          mouse = container.interactivity.mouse,
          events = container.actualOptions.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      return isInArray("connect", events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var container, options, mousePos, distance, query, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p1, pos1, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, p2, pos2, distMax, xDiff, yDiff;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, options = container.actualOptions;

                if (!(options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove")) {
                  _context.next = 52;
                  break;
                }

                mousePos = container.interactivity.mouse.position;

                if (mousePos) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                distance = Math.abs(container.retina.connectModeRadius), query = container.particles.quadTree.queryCircle(mousePos, distance);
                i = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = query[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 38;
                  break;
                }

                p1 = _step.value;
                pos1 = p1.getPosition();
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 18;

                for (_iterator2 = query.slice(i + 1)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  p2 = _step2.value;
                  pos2 = p2.getPosition(), distMax = Math.abs(container.retina.connectModeDistance), xDiff = Math.abs(pos1.x - pos2.x), yDiff = Math.abs(pos1.y - pos2.y);

                  if (xDiff < distMax && yDiff < distMax) {
                    container.canvas.drawConnectLine(p1, p2);
                  }
                }

                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](18);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError2) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                ++i;

              case 35:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 38:
                _context.next = 44;
                break;

              case 40:
                _context.prev = 40;
                _context.t1 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 44:
                _context.prev = 44;
                _context.prev = 45;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 47:
                _context.prev = 47;

                if (!_didIteratorError) {
                  _context.next = 50;
                  break;
                }

                throw _iteratorError;

              case 50:
                return _context.finish(47);

              case 51:
                return _context.finish(44);

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 40, 44, 52], [18, 22, 26, 34], [27,, 29, 33], [45,, 47, 51]]);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }]);

  return Connector;
}(ExternalInteractorBase);